export const IMAGE_SERVER_BASE_URL = "https://admin.monsinidress.com";

function getImageValue(value) {
	if (!value) return "";

	if (typeof value === "string") {
		return value.trim();
	}

	if (typeof value === "object") {
		return String(
			value.url ||
			value.src ||
			value.path ||
			value.imageUrl ||
			value.imageURL ||
			""
		).trim();
	}

	return String(value).trim();
}

export function resolveImageUrl(value) {
	const imageValue = getImageValue(value);

	if (!imageValue) return "";

	if (/^(https?:\/\/|data:|blob:)/i.test(imageValue)) {
		return imageValue;
	}

	if (imageValue.startsWith("//")) {
		return `https:${imageValue}`;
	}

	return `${IMAGE_SERVER_BASE_URL}/${imageValue.replace(/^\/+/, "")}`;
}

export function getProductImageUrl(product, index = 0) {
	if (!product) return "";

	const images = Array.isArray(product.images) ? product.images : [];
	const indexedImage = images[index];

	const candidates =
		index === 0
			? [
				product.url,
				product.imageUrl,
				product.imageURL,
				product.image,
				product.src,
				indexedImage,
			]
			: [indexedImage];

	for (const candidate of candidates) {
		const resolved = resolveImageUrl(candidate);
		if (resolved) return resolved;
	}

	return "";
}
